//import { Component } from '@angular/core';
import { App, NavController, NavParams,LoadingController, ToastController, Events } from 'ionic-angular';
import { HomePage } from '../home/home';
import { PostPicPage } from '../post-pic/post-pic';
import { CommentViewPage } from '../comments-view/comments-view';
import { VoteBankPage } from '../vote-bank/vote-bank';
import { ApiService } from '../../api-service/api-service';
import { SocialSharing } from '@ionic-native/social-sharing';

import { Component, ViewChild } from '@angular/core';
import { updateImgs } from 'ionic-angular/components/content/content';
import { Img } from 'ionic-angular/components/img/img-interface';
import { Content } from 'ionic-angular';

import { User,UserPost,UserComment,UserData,Ladder } from '../../providers/providers';
import { dateDataSortValue } from 'ionic-angular/util/datetime-util';

declare var AWS: any;
declare const aws_user_files_s3_bucket;
declare const aws_user_files_s3_bucket_region;


@Component({
  selector: 'page-userposts',
  templateUrl: 'user-posts.html'
})
export class UserPostPage {

  public postPicPage = PostPicPage;
  public commentViewPage = CommentViewPage;
  public voteBankPage = VoteBankPage;
  public category:Ladder = new Ladder();
  public changedCategory:Ladder;
  items:UserPost[] = [];
  itemSort:UserPost[] = [];

  private s3: any;
  public sub: string = null;
  public lastKey: any;
  public IScroll:any;
  public ladders:Ladder[] = [];
  public lastVoteDate:string;

  public timeLeft:number = 60;
  public days:number
  public hours:number;
  public minutes:number;
  public seconds:number;
  private timerStarted:boolean = false;
  public userName:string;
  public ladderUserName:string;
  public ladderAvatarURL:string;

  constructor(public navCtrl: NavController,public navParams:NavParams,public server:ApiService,
    public user:User,
    public toastCtrl: ToastController, public userData:UserData, public events:Events, public socialShare:SocialSharing) {
      
      this.s3 = new AWS.S3({
        'params': {
          'Bucket': aws_user_files_s3_bucket
        },
        'region': aws_user_files_s3_bucket_region
      });
      this.category = new Ladder();

      if (navParams.get('userName')){
        this.ladderUserName = navParams.get('userName');
      }
      if (navParams.get('userAvatar')){
        this.ladderAvatarURL = navParams.get('userAvatar');
      }
      this.userName = this.user.getUsername();

      //this.userData.refreshUserData();

      this.server.getUserPosts(this.ladderUserName,"",this.getPostsCallBack);

  }

  avatarUpdatedCallback= (data) => {
    this.avatarUpdated(data);
  }

  avatarUpdated(data){
    let test = data;
  }

  

  /* 2017-08-16 - add this to class body
    start FIX#9660 ion-img doesn't correctly work with virtualScroll
    https://github.com/ionic-team/ionic/issues/9660#issuecomment-304840427
*/
@ViewChild(Content) _content: Content;
ngAfterViewInit() {
    if (this._content) {
        this._content.imgsUpdate = () => {
            if (this._content._scroll.initialized && this._content._imgs.length && this._content.isImgsUpdatable()) {
                // reset cached bounds
                this._content._imgs.forEach((img: Img) => (<any>img)._rect = null);
                // use global position to calculate if an img is in the viewable area
                updateImgs(this._content._imgs, this._content._cTop * -1, this._content.contentHeight, this._content.directionY, 1400, 400);
            }
        };
    }
}
/*
end FIX#9660
*/

  /*comments(postId){
    let testComment = new UserComment(postId);
    //let testComment = new UserComment(postId,this.user.getUsername());
    //this.server.postComment(testComment);
  }
*/
  addPost(){
    
    let newPost = new UserPost(this.category.Category);
    this.navCtrl.push(this.postPicPage,{userPost:newPost});
  }

  checkGenerator(){
    this.navCtrl.push(this.voteBankPage);
  }

  comments(postId){
    this.navCtrl.push(this.commentViewPage,{userPostId:postId});
  }

  /*ladderSelected(event){
    if(event === this.changedCategory)
    {
      //error in framework workaround
      return;
    }
    this.items = [];
    this.category = this.setLadder(event);
    this.changedCategory = this.category;
    this.getCategoryCountdown(this.category.VoteEnding);
    this.setLastCategoryDate();
    this.server.getPics(this.category.Category,null,this.getPostsCallBack);
    this.events.subscribe("PostAdded:"+this.category.Category, (postEventData) =>{
      this.items = [];
      this.server.getPics(this.category.Category,null,this.getPostsCallBack);
    });
  }


  countDownSecond(){
    this.seconds -= 1;
    let tickMinute = false;
    let tickHour = false;
    let tickDay = false;
    if(this.days ===0 && this.hours === 0 && this.minutes === 0 && this.seconds === 0){
        //TODO reset timer  
      //this.server.checkVoteGenerator();
    }

    if(this.seconds === 0){
       tickMinute = true;
       this.seconds = 59;
    }
    if(tickMinute === true){
      if(this.minutes === 0){
        this.minutes = 59;
        tickHour = true;
      }
      else{
      this.minutes -= 1
      }
      tickMinute = false;
    }
    if(tickHour === true ){
      if(this.hours === 0){
        this.hours = 23;
        tickDay = true;
      }
      else
      {
        this.hours -= 1;
      }
      tickHour = false;
    }
    if(tickDay === true){
      this.days -= 1;
      tickDay = false;
    }

    //if(this.hours < 0){
    //  this.server.checkVoteGenerator(this.checkBankCallBack);
    // }
  }

  private StartTimerCountdown() {
    this.timerStarted = true;
    return setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft -= 1;
        this.countDownSecond();
      }
      else {
        this.server.getCategories(this.getCategoryCallBack);;
      }
    }, 1000);
  }

  getCategoryCountdown(categoryResetDate:string){
    let resetDate = new Date(categoryResetDate);
    resetDate.setUTCHours(resetDate.getUTCHours());
    let currentTimeISO = new Date().toISOString();
    let currentTime = new Date(currentTimeISO);
    this.timeLeft = ( resetDate.getTime() - currentTime.getTime()) / 1000;

    //let seocondsDate = new Date(null);
    //seocondsDate.setSeconds(this.timeLeft);
    let workingSeconds = this.timeLeft;
    this.days = Math.floor(workingSeconds / 60 / 60 / 24);
    let daysHoursMins = this.days * 60 * 60 * 24;
    workingSeconds = workingSeconds - daysHoursMins;

    this.hours = Math.floor(workingSeconds / 60 / 60);
    let hoursMins = this.hours * 60 * 60;
    workingSeconds = workingSeconds - hoursMins;
    if(workingSeconds > 60)
    {
      this.minutes = Math.floor(workingSeconds / 60);
    }
    else
    {
      this.minutes = 0;
    }
    let minsSeconds = this.minutes * 60;
    workingSeconds = Math.floor(workingSeconds - minsSeconds);
    this.seconds = workingSeconds;

    if(!this.timerStarted){
      var timer = this.StartTimerCountdown();
    }
    
  }

  public setLadder(selectedCategory){
    for(let i=0;i<this.ladders.length;i++){
      if(this.ladders[i].Category === selectedCategory.Category){
        return this.ladders[i];
      }
    }

  }
  
  generateTestPosts(){
    for (let i = 0; i < 30; i++) {
        let fakePost = new UserPost("Funny");
        fakePost.generateTestPost();
        this.items.push( fakePost );
        }
    }
    */

      //Fat arrow used to keep scope, private entry back in
  public getPostsCallBack = (posts) => {
    this.getPosts(posts);
  }
  getPosts(userPosts){

    if(userPosts.LastEvaluatedKey){
      this.lastKey = userPosts.LastEvaluatedKey;
    }
    else
    {
      this.lastKey = "";
    }

    this.itemSort = [];
    for (let i = 0; i < userPosts.Items.length; i++) {
      this.s3.getSignedUrl('getObject', {'Key': userPosts.Items[i].picKey}, (err, url) => {
        userPosts.Items[i].picURL = url;
        //this.items.push( userPosts[i] );
        this.s3.getSignedUrl('getObject', {'Key': userPosts.Items[i].avatarKey}, (err, avatarUrl) => {
          userPosts.Items[i].avatarURL = avatarUrl;
          //this.items.push( userPosts.Items[i] );
          this.itemSort.push( userPosts.Items[i]);
          if(this.itemSort.length === userPosts.Items.length)
          {
            this.updatePostList();
          }
        });
      });

      //this.setLastCategoryDate();

        //this.items.push( userPosts[i] );
        }
        if(this.IScroll){
          this.IScroll.complete();
        }
    }
  
    public updatePostList(){
      this.itemSort.sort((leftSide,rightSide):number=> {
      if(leftSide.postTimeStamp > rightSide.postTimeStamp) return -1;
      if(leftSide.postTimeStamp < rightSide.postTimeStamp) return 1;
      return 0;
    });
      for (let i=0; i<this.itemSort.length; i++){
        this.items.push(this.itemSort[i]);
      }
      //this.setLastCategoryDate();
    }
    

  parseISOString(s) {
      var b = s.split(/\D+/);
      return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  }

  public getDayNumber(dayEnding){
    if(dayEnding === "SUN"){
      return 0;
    }
    if(dayEnding === "MON"){
      return 1;
    }
    if(dayEnding === "TUE"){
      return 2;
    }
    if(dayEnding === "WED"){
      return 3;
    }
    if(dayEnding === "THU"){
      return 4;
    }
    if(dayEnding === "FRI"){
      return 5;
    }
    if(dayEnding === "SAT"){
      return 6;
    }
  }

 
    voteForPost(Post){
      
      if(this.userData.votes > 0)
      {
        this.server.voteForPic(Post,this.voteForPostCallBack);
      }
      else
      {
        alert ("Out of Votes Try again later!");
      }
    }

    public voteForPostCallBack = (postsVotedOn:UserPost) => {
      this.updateVote(postsVotedOn);
    }

    updateVote(postsVotedOn:UserPost){
      postsVotedOn.votes = postsVotedOn.votes+1
      this.userData.votes = this.userData.votes - 1;  
    }

    
    public deletePost(postToDelete:UserPost){
      let deleteConfirm = confirm("delete post "+postToDelete.message.substr(0,50)+"?");
      if(deleteConfirm){
        this.server.deletePic(postToDelete,this.deletePostCallBack);
        //alert("implement delete!");
      }
    }

    public deletePostCallBack = (postDeleted:UserPost) => {
      this.postDeleted(postDeleted);
    }

    postDeleted(postDeleted:UserPost){
      for(let i = 0; i< this.items.length; i++){
        if(this.items[i].UserPostId === postDeleted.UserPostId){
            this.items.splice(i,1);
          break;
        }
      } 
    }

    regularShare(index){
      var msg = "test message";
      this.socialShare.share(msg, null, null, null);
    }


    
  doInfinite(infiniteScroll) {
    this.IScroll = infiniteScroll;
    console.log('Begin async operation');
    if (this.lastKey !== "")
    {
      this.server.getPics(this.category.Category,this.lastKey,this.getPostsCallBack);
    }
    else
    {
      infiniteScroll.complete();
    }
    /*setTimeout(() => {
      for (let i = 0; i < 30; i++) {
          let fakePost = new UserPost("Funny");
          fakePost.generateTestPost();
        this.items.push( fakePost );
      }

      console.log('Async operation has ended');
      infiniteScroll.complete();
    }, 500);
    */
  }

}



// WEBPACK FOOTER //
// ./src/pages/user-posts/user-posts.ts